import { theme as antdTheme } from 'antd'
import type { ThemeConfig } from 'antd'
import { colors } from './colors'

export const tacticalTheme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    colorPrimary: colors.primary500,
    colorInfo: colors.primary400,
    colorSuccess: colors.success500,
    colorWarning: colors.accent500,
    colorError: colors.alert500,

    colorBgBase: colors.bgBase,
    colorBgContainer: colors.bgSurface,
    colorBgElevated: colors.bgElevated,
    colorBgLayout: colors.bgBase,

    colorBorder: colors.borderSubtle,
    colorBorderSecondary: colors.borderStrong,

    colorTextBase: colors.textPrimary,
    colorText: colors.textPrimary,
    colorTextSecondary: colors.textSecondary,
    colorTextTertiary: colors.textMuted,

    fontFamily:
      '"Inter", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
    fontFamilyCode:
      '"JetBrains Mono", ui-monospace, Consolas, monospace',
    fontSize: 14,

    borderRadius: 6,
    controlHeight: 36,

    wireframe: false,
  },
  components: {
    Layout: {
      headerBg: colors.bgSurface,
      headerHeight: 56,
      siderBg: colors.bgSurface,
      bodyBg: colors.bgBase,
      footerBg: colors.bgSurface,
    },
    Menu: {
      itemBg: 'transparent',
      itemSelectedBg: colors.primary700,
      itemSelectedColor: colors.primary400,
      itemHoverBg: colors.bgElevated,
      itemHoverColor: colors.primary400,
      darkItemBg: 'transparent',
      darkItemSelectedBg: colors.primary700,
      darkItemSelectedColor: colors.primary400,
      darkItemHoverBg: colors.bgElevated,
    },
    Card: {
      headerBg: colors.bgElevated,
      colorBgContainer: colors.bgSurface,
    },
    Table: {
      headerBg: colors.bgElevated,
      rowHoverBg: colors.bgElevated,
    },
    Button: {
      controlHeight: 36,
    },
    Input: {
      controlHeight: 36,
    },
    Tag: {
      defaultBg: colors.bgElevated,
    },
  },
}
